import * as React from 'react';
import Flex from '../Flex/Flex';
import './RadioButton.css';

export interface Props extends React.InputHTMLAttributes<HTMLInputElement> {}

/**
 * Run-of-the-mill RadioButton component.
 */
const RadioButton: React.FunctionComponent<Props> = (props: Props) => {
  const { children, ...rest } = props;

  return (
    <Flex
        Component="label"
        alignChildrenVertical="middle"
        className="RadioButton"
        direction="horizontal"
        gap="x2">
      <Flex>
        <input { ...rest }
            className="RadioButton__input"
            type="radio" />
        <Flex
            alignChildren="middle"
            className="RadioButton__indicator"
            direction="horizontal">
          <span className="RadioButton__circle" />
        </Flex>
      </Flex>

      { children && (
        <Flex textColor="grape-5">
          { children }
        </Flex>
      ) }
    </Flex>
  );
};

export default RadioButton;
